import { Fragment } from 'react';

import useFrequentFlyerFormGrid from './UseFrequentFlyerFormGrid';

import FrequentFlyerFormGridLarge from './FrequentFlyerFormGridLarge';
import FrequentFlyerFormGridSmall from './FrequentFlyerFormGridSmall';

import Spinner from '@usas/ui-web/components/spinners/Spinner';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

const FrequentFlyerFormGrid = ({ gridData, personId, onSubmitFormCallback, onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    isLoading,
    isDirty,
    formGridState,
    onUpdateFormGridState,
    onSubmitFormGrid,
    onCancelClicked
  } = useFrequentFlyerFormGrid(gridData, personId, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught);

  if (isLoading === true) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <FrequentFlyerFormGridLarge formGridState={formGridState} onUpdateFormGridState={onUpdateFormGridState} />
      <FrequentFlyerFormGridSmall formGridState={formGridState} onUpdateFormGridState={onUpdateFormGridState} />
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="button" isDisabled={isDirty === false} onClick={onSubmitFormGrid}>Save</PrimaryButton>&nbsp;
          {isDirty === true && <SecondaryButton type="button" onClick={onCancelClicked}>Cancel</SecondaryButton>}
        </div>
      </div>
    </Fragment>
  );
};

export default FrequentFlyerFormGrid;